import { Schema } from '@core/data/dto/schema';

export const ChildSupportSchema = {
    id: Schema.String,
    agency: Schema.String,
    amount: Schema.Number,
    external_id: Schema.String,
    fips_code: Schema.String,
    max_percent: Schema.Number,
    issue_date: Schema.Moment,
    managed: Schema.Boolean
}
